import { defineAction } from '~/prix'
import { z } from 'zod'
import waterSourceApplicationReportAction from './waterSourceApplicationReport.action.json' with { type: 'json' }
import { waterSourceApplicationReportTypeSchema } from './waterSourceApplicationReportShared'

const waterSourceApplicationReportDefinition = defineAction({
  ...waterSourceApplicationReportAction,

  input: z.object({
    id: z.string().uuid(),
    reportType: waterSourceApplicationReportTypeSchema,
    format: z.literal('pdf').default('pdf'),
  }),
  output: z.any(),
})

export default waterSourceApplicationReportDefinition
